import React, { useState, useEffect } from "react";
import Api from "Api/Api";
import Auth from "Api/Auth";
import { connect } from "react-redux";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { startupStatusColorMap } from "formFields";
// import { SelectBox } from "devextreme-react";
// import { startupStatus } from "formFields";
import moment from "moment";
import StartupInvestmentDetails from "components/AdminComponents/StartupInvestmentDetails";

function SeeDeals({ dispatch, formFields }) {
  const [startups, setStartups] = useState(null);
  const [selectedStartup, setSelectedStartup] = useState(null);
  const [id, setId] = useState(null);


  useEffect(() => {
    const investorId = Auth.decodedToken().investorId;
    setId(investorId);
    dispatch({
      type: "SectionSelected",
      payload: `See Deals`,
    });
  }, []);

  useEffect(() => {
    if (id) {
      getStartups();
    }
  }, [id]);

  const getStartups = async (filters = null) => {
    dispatch({ type: "toggleLoad" });
    const response = await Api.getStartupFromInvestorID(id, null, filters);
    // const response = await Api.getStartupFromInvestorID(id);
    dispatch({ type: "toggleLoad" });
    if (response.status === 200) {
      setStartups(response.data);
    }
  };

  return (
    <div className="card">
      <div className="card-header card-header-primary">
        <div className="ct-chart" id="completedTasksChart">
          <div className="row">
            <div className="col-lg-9">
              <div style={{ textTransform: "capitalize" }}>
                <h4>See Deals</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <DataGrid
          dataSource={startups}
          wordWrapEnabled={true}
          hoverStateEnabled={true}
          keyExpr={"startup.id"}
        >
          <Column dataField={"startup.name"} caption="Name" />
          <Column dataField={"startup.stage"} caption="Stage" />
          <Column dataField={"startup.ask_amount"} caption="Ask amount" />
          <Column dataField={"startup.sector"} caption="Sector" />
          <Column dataField={"startup.industry"} caption="Industry" />
          <Column dataField={"startup.segment"} caption="Segment" />
          <Column
            dataField={"chat_description"}
            caption="Last chat description"
          />
          <Column dataField={"status"} caption="Status" cellRender={(row) => {
            const color = startupStatusColorMap[row.data.status];
            return <>
              <span
                className={`badge badge-pill outlined text-${color} border-${color}`}>
                {row.data.status}
              </span>
              {
                row.data.status === "Committed" ? <div className="badge badge-pill outlined pointer text-success border-success" onClick={() => setSelectedStartup(row.data.startup.id)}>Investment details</div> : ""
              }
            </>
          }} />
          <Column
            dataField={"created"}
            caption="Assigned"
            cellRender={(row) => {
              return <span>{moment(row.data.created).format("LLL")}</span>;
            }}
          />
        </DataGrid>
      </div>
      <StartupInvestmentDetails
        id={selectedStartup}
        investorId={id}
        onClose={() => setSelectedStartup(null)}
        readonly={true}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    formFields: state.formFields,
  };
}
export default connect(mapStateToProps)(SeeDeals);
